import { Box, Typography } from '@mui/material'
import React from 'react'

const ErrorNotFound: React.FC = () => (
    <Box>
        <Typography fontSize="6rem" fontWeight={700}>
            404
        </Typography>
        <Typography>Oops, cette page n'existe pas!</Typography>
    </Box>
)

export default ErrorNotFound
